import { Trans } from "@lingui/react/macro";
import type { DrokMyCopy } from "@rakazo/contracts";

/** The skills IT put in a copy's template, read-only. Built-in skills are not listed on a copy. */
export function CopySkills({ skills }: { skills: DrokMyCopy["skills"] }) {
  return (
    <section className="mt-6" data-testid="copy-skills">
      <h3 className="mb-2 text-xs font-medium text-muted-foreground">
        <Trans>Skills</Trans>
      </h3>
      {skills.length === 0 ? (
        <p className="rounded-xl bg-muted/50 p-4 text-sm text-muted-foreground">
          <Trans>No skills yet</Trans>
        </p>
      ) : (
        <ul className="divide-y divide-border rounded-xl bg-muted/50 px-4">
          {skills.map((skill) => (
            <li key={skill.name} className="py-2.5">
              <p className="truncate text-[14.5px] font-medium text-foreground" dir="auto">
                {skill.name}
              </p>
              <p className="mt-0.5 text-[12.5px] text-muted-foreground" dir="auto">
                {skill.description}
              </p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
